module.exports = __webpack_public_path__ + "static/media/Badge_SvgAppConnecte_Gold.fa9dbd5e.svg";